import { Collapse, Dialog } from '@blueprintjs/core';
import { GiaiQuyetDonThu, ThanhTra } from 'api';
import {
  DropDownMulipleUse
} from 'components/tt-forms';
import { DatePicker, Input, InputList, InputNumber, TextArea } from 'components/tt-forms/common';
import { ContainerFileDinhKem } from 'components/upload';
import { ShowIf, validatable } from 'components/utils';
import { msg } from 'constants/message';
import { ConfirmDialog } from 'modules/dialog';
import { Toastr } from 'modules/toastr';
import moment from 'moment';
import React from 'react';
import { Link } from 'react-router';
import ListDonDoc from './ListDonDoc.jsx';
import ListLanNopTien from './ListLanNopTien.jsx';
import NoiDungKienNghiDoiTuongThanhTra from './NoiDungKienNghiDoiTuongThanhTra.jsx';
import style from './style.scss';

const loaiQuyTrinh = 'THEO_DOI_THUC_HIEN_SAU_THANH_TRA';

class DoiTuongKienNghi extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dataDetail: {},
      style: style,
      showFile: true,
      action: false,
      isOpen: this.props.isOpen,
      showNoiDungKienNghi: true,
      showNoiDungTheoDoi: true,
      showNoiDungDonDoc: true,
      showNoiDungKiemTra: true,
      getThoiHanKiemTra: false,
      donDocChange: false,
      confirmDonDoc: false,
      showDialogConfirm: false,
      btnLoading: false,
      btnSaveLoading: false,
      enableTheoDoi: false,
      enableDonDoc: false,
      enableKiemTra: false,
      backConfirm: false,
      hasChange: false,

      idCuocThanhTra: this.props.idCuocThanhTra,
      id: this.props.id,

      ten: '',

      linhVucThanhTra: this.props.linhVucThanhTra,
      listDoiTuongViPham: this.props.listDoiTuongViPham,
      chucNangCuocThanhTra: this.props.chucNangCuocThanhTra,

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dataCoQuanDieuTraThanhTra: [],
      dataHinhThucKienNghi: [],

      listTaiLieuVanThuGiaHan: [],
      danhSachDonViPhoiHop: [],
      listTaiLieuVanThu: [],
      donViPhoiHop: '',
      trangThaiDoiTuongViPham: '',

      //data option

      dataKetQuaTheoDoiSaiPham: [],
      dataKetQuaChuyenCoQuanDieuTra: [],
      dataKetLuanVeNoiDungKiemTra: [],

      //Theo doi thuc hien
      theoDoiTienDaThuHoiVeNganSachNhaNuoc: '',
      theoDoiDatDaThuHoiVeNganSachNhaNuoc: '',
      theoDoiTienDaThuTrongQuaTrinhThanhTra: '',
      theoDoiDatDaThuTrongQuaTrinhThanhTra: '',

      soQuyetDinhTheoDoiXuLyHanhChinh: '',

      theoDoiToChucCoSaiPham: '',
      theoDoiToChucCoSaiPhamInit: '',
      toChucTheoDoiSaiPham: '',

      theoDoiCaNhanCoSaiPham: '',
      theoDoiCaNhanCoSaiPhamInit: '',
      caNhanTheoDoiSaiPham: '',

      // xử lý về kinh tế

      tongSoTienThuHoiTheoDoiXuLyVeKinhTe: '',

      listTheoDoiLanNopTien: [],

      lyDoThuHoiTheoDoiXuLyVeKinhTe: '',

      saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe: '',
      saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe: '',
      saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe: '',

      lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe: '',

      saiPhamKhacTheoDoiXuLyVeKinhTe: '',

      // xử lý về hành chính
      theoDoiKienNghiXuLyHanhChinhToChucBangTien: '',
      theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac: '',
      theoDoiKienNghiXuLyHanhChinhCaNhanBangTien: '',
      theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac: '',



      // xử lý về hình sự
      vanBanDonDocCoQuanDieuTraTheoDoiHinhSu: '',
      ketQuaChuyenCoQuanDieuTra: '',
      soVuViecTheoDoiXuLyHinhSu: '',

      soDoiTuongTheoDoiXuLyHinhSuInit: '',
      soDoiTuongTheoDoiXuLyHinhSu: '',

      ghiChuTheoDoiXuLyHinhSu: '',

      kienNghiTienTheoDoiXuLyKhac: '',
      kienNghiDatTheoDoiXuLyKhac: '',
      ketQuaThucHienTheoDoiXuLyKhac: '',
      // end theo dõi thực hiện

      // Kết quả kiểm tra

      soQuyetDinhKiemTra: '',
      ngayBanHanhKiemTra: '',
      ngayBatDauKiemTra: '',
      thoiHanKiemTra: '',
      ngayHetHanKiemTra: '',
      ngayHetHanKiemTraISO: '',
      canCuKiemTra: '',
      tinhHinhKiemTra: '',
      ketQuaKiemTra: '',
      linhVucKetQuaThanhTra: '',
      soKienNghiDaThucHienXong: null,
      // end kết quả kiểm tra
    }
  }

  componentDidMount() {
    this.getCoQuanDieuTraThanhTra();
    this.getHinhThucKienNghi();
    this.ketQuaTheoDoiSaiPham();
    this.ketQuaChuyenCoQuanDieuTra();
    this.getKetLuanVeNoiDungKiemTra();
    if (this.state.id) {
      this.getChiTietDoiTuongTraThanhTra(this.state.id)
    }
  }

  ketQuaChuyenCoQuanDieuTra() {
    ThanhTra.actions.ketQuaChuyenCoQuanDieuTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataKetQuaChuyenCoQuanDieuTra: res.data
        })
      }
    })
  }

  ketQuaTheoDoiSaiPham() {
    ThanhTra.actions.ketQuaTheoDoiSaiPham.request().then(res => {
      if (res.data) {
        this.setState({
          dataKetQuaTheoDoiSaiPham: res.data
        })
      }
    })
  }

  getChiTietDoiTuongTraThanhTra(id) {
    ThanhTra.actions.getChiTietDoiTuongTraThanhTra.request({ id: id }).then(res => {
      if (res.data) {
        this.setState({
          dataDetail: res.data,
          doiTuongViPhamId: res.data.doiTuongViPhamId,

          ten: res.data.ten,
          // theo doi thuc hien
          theoDoiTienDaThuHoiVeNganSachNhaNuoc: res.data.theoDoiTienDaThuHoiVeNganSachNhaNuoc ? res.data.theoDoiTienDaThuHoiVeNganSachNhaNuoc : '',
          theoDoiDatDaThuHoiVeNganSachNhaNuoc: res.data.theoDoiDatDaThuHoiVeNganSachNhaNuoc ? res.data.theoDoiDatDaThuHoiVeNganSachNhaNuoc : '',
          theoDoiTienDaThuTrongQuaTrinhThanhTra: res.data.theoDoiTienDaThuTrongQuaTrinhThanhTra ? res.data.theoDoiTienDaThuTrongQuaTrinhThanhTra : '',
          theoDoiDatDaThuTrongQuaTrinhThanhTra: res.data.theoDoiDatDaThuTrongQuaTrinhThanhTra ? res.data.theoDoiDatDaThuTrongQuaTrinhThanhTra : '',

          soQuyetDinhTheoDoiXuLyHanhChinh: res.data.soQuyetDinhTheoDoiXuLyHanhChinh ? res.data.soQuyetDinhTheoDoiXuLyHanhChinh : '',

          theoDoiToChucCoSaiPham: res.data.theoDoiToChucCoSaiPham ? res.data.theoDoiToChucCoSaiPham : '',
          theoDoiToChucCoSaiPhamInit: res.data.theoDoiToChucCoSaiPham ? res.data.theoDoiToChucCoSaiPham : '',
          toChucTheoDoiSaiPham: res.data.toChucTheoDoiSaiPham ? res.data.toChucTheoDoiSaiPham : '',

          theoDoiCaNhanCoSaiPham: res.data.theoDoiCaNhanCoSaiPham ? res.data.theoDoiCaNhanCoSaiPham : '',
          theoDoiCaNhanCoSaiPhamInit: res.data.theoDoiCaNhanCoSaiPham ? res.data.theoDoiCaNhanCoSaiPham : '',
          caNhanTheoDoiSaiPham: res.data.caNhanTheoDoiSaiPham ? res.data.caNhanTheoDoiSaiPham : '',

          listTheoDoiLanNopTien: res.data.listTheoDoiLanNopTien ? res.data.listTheoDoiLanNopTien : [],

          tongSoTienThuHoiTheoDoiXuLyVeKinhTe: res.data.tongSoTienThuHoiTheoDoiXuLyVeKinhTe ? res.data.tongSoTienThuHoiTheoDoiXuLyVeKinhTe : '',


          lyDoThuHoiTheoDoiXuLyVeKinhTe: res.data.lyDoThuHoiTheoDoiXuLyVeKinhTe ? res.data.lyDoThuHoiTheoDoiXuLyVeKinhTe : '',

          saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe: res.data.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe ? res.data.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe : '',
          saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe: res.data.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe ? res.data.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe : '',
          saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe: res.data.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe ? res.data.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe : '',

          lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe: res.data.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe ? res.data.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe : '',

          saiPhamKhacTheoDoiXuLyVeKinhTe: res.data.saiPhamKhacTheoDoiXuLyVeKinhTe ? res.data.saiPhamKhacTheoDoiXuLyVeKinhTe : '',

          vanBanDonDocCoQuanDieuTraTheoDoiHinhSu: res.data.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu ? res.data.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu : '',
          ketQuaChuyenCoQuanDieuTra: res.data.ketQuaChuyenCoQuanDieuTra ? res.data.ketQuaChuyenCoQuanDieuTra : '',

          soVuViecTheoDoiXuLyHinhSu: res.data.soVuViecTheoDoiXuLyHinhSu ? res.data.soVuViecTheoDoiXuLyHinhSu : '',

          soDoiTuongTheoDoiXuLyHinhSu: res.data.soDoiTuongTheoDoiXuLyHinhSu ? res.data.soDoiTuongTheoDoiXuLyHinhSu : '',
          soDoiTuongTheoDoiXuLyHinhSuInit: res.data.soDoiTuongTheoDoiXuLyHinhSu ? res.data.soDoiTuongTheoDoiXuLyHinhSu : '',

          ghiChuTheoDoiXuLyHinhSu: res.data.ghiChuTheoDoiXuLyHinhSu ? res.data.ghiChuTheoDoiXuLyHinhSu : '',

          kienNghiTienTheoDoiXuLyKhac: res.data.kienNghiTienTheoDoiXuLyKhac ? res.data.kienNghiTienTheoDoiXuLyKhac : '',
          kienNghiDatTheoDoiXuLyKhac: res.data.kienNghiDatTheoDoiXuLyKhac ? res.data.kienNghiDatTheoDoiXuLyKhac : '',
          ketQuaThucHienTheoDoiXuLyKhac: res.data.ketQuaThucHienTheoDoiXuLyKhac ? res.data.ketQuaThucHienTheoDoiXuLyKhac : '',

          listTaiLieuVanThu: res.data.listTaiLieuVanThu,

          //end theo doi

          // ket qua kiem tra
          soQuyetDinhKiemTra: res.data.soQuyetDinhKiemTra ? res.data.soQuyetDinhKiemTra : '',
          ngayBanHanhKiemTra: res.data.ngayBanHanhKiemTra ? new Date(res.data.ngayBanHanhKiemTra) : '',
          ngayBatDauKiemTra: res.data.ngayBatDauKiemTra ? new Date(res.data.ngayBatDauKiemTra) : '',
          thoiHanKiemTra: res.data.thoiHanKiemTra ? res.data.thoiHanKiemTra : 0,
          ngayHetHanKiemTra: res.data.ngayHetHanKiemTra ? moment(res.data.ngayHetHanKiemTra).format('DD/MM/YYYY') : '',
          ngayHetHanKiemTraISO: res.data.ngayHetHanKiemTra ? res.data.ngayHetHanKiemTra : null,
          canCuKiemTra: res.data.canCuKiemTra ? res.data.canCuKiemTra : '',
          tinhHinhKiemTra: res.data.tinhHinhKiemTra ? res.data.tinhHinhKiemTra : '',
          ketQuaKiemTra: res.data.ketQuaKiemTra ? res.data.ketQuaKiemTra : '',
          linhVucKetQuaThanhTra: res.data.linhVucKetQuaThanhTra ? res.data.linhVucKetQuaThanhTra.giaTri : '',

          // Kiến nghị xử lý hành chính
          theoDoiKienNghiXuLyHanhChinhToChucBangTien: res.data.theoDoiKienNghiXuLyHanhChinhToChucBangTien ? res.data.theoDoiKienNghiXuLyHanhChinhToChucBangTien : '',
          theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac: res.data.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac ? res.data.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac : '',
          theoDoiKienNghiXuLyHanhChinhCaNhanBangTien: res.data.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien ? res.data.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien : '',
          theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac: res.data.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac ? res.data.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac : '',
          soKienNghiDaThucHienXong: res.data.soKienNghiDaThucHienXong ? res.data.soKienNghiDaThucHienXong : null,
        }, () => {
          this.checkTienDo()
        })
      }
    })
  }

  checkTienDo() {
    let DataDetail = { ...this.state.dataDetail }
    if (DataDetail.tinhTrangThoiHanInfo && DataDetail.tinhTrangThoiHanInfo.type === 'DAY' && DataDetail.tinhTrangThoiHanInfo.value < 1) {
      switch (DataDetail.tienDo) {
        case 'THEO_DOI':
          this.setState({
            enableTheoDoi: true,
            enableDonDoc: true,
            enableKiemTra: false
          })
          break;
        case 'DON_DOC':
          this.setState({
            enableTheoDoi: true,
            enableDonDoc: true,
            enableKiemTra: true
          })
          break;
        case 'HOAN_THANH':
        case 'KIEM_TRA':
          this.setState({
            enableTheoDoi: true,
            enableDonDoc: true,
            enableKiemTra: true
          })
          break;
      }
    } else {
      switch (DataDetail.tienDo) {
        case 'THEO_DOI':
          this.setState({
            enableTheoDoi: true,
            enableDonDoc: false,
            enableKiemTra: false
          })
          break;
        case 'DON_DOC':
          this.setState({
            enableTheoDoi: true,
            enableDonDoc: true,
            enableKiemTra: false
          })
          break;
        case 'HOAN_THANH':
        case 'KIEM_TRA':
          this.setState({
            enableTheoDoi: true,
            enableDonDoc: true,
            enableKiemTra: true
          })
          break;
      }
    }
  }

  getParams() {
    let params = this.state.dataDetail;
    if (this.state.listTheoDoiLanNopTien.length > 0) {
      let listTheoDoiLanNopTien = [];
      this.state.listTheoDoiLanNopTien.map(state => {
        let item = {
          ngayNopTien: state.ngayNopTien ? moment(new Date(state.ngayNopTien)).add(7, 'hours').toISOString() : null,
          soTien: state.soTien ? state.soTien : '',
          tongCong: state.tongCong ? state.tongCong : '',
          conPhaiThu: state.conPhaiThu ? state.conPhaiThu : ''
        }

        listTheoDoiLanNopTien[listTheoDoiLanNopTien.length] = item;
      })
      params.listTheoDoiLanNopTien = listTheoDoiLanNopTien;
    } else {
      params.listTheoDoiLanNopTien = []
    }

    params.id = this.state.id;

    params.cuocThanhTra = {
      id: Number(this.state.idCuocThanhTra)
    }
    params.theoDoiTienDaThuHoiVeNganSachNhaNuoc = this.state.theoDoiTienDaThuHoiVeNganSachNhaNuoc ? this.state.theoDoiTienDaThuHoiVeNganSachNhaNuoc : '';
    params.theoDoiDatDaThuHoiVeNganSachNhaNuoc = this.state.theoDoiDatDaThuHoiVeNganSachNhaNuoc ? this.state.theoDoiDatDaThuHoiVeNganSachNhaNuoc : '';

    params.theoDoiTienDaThuTrongQuaTrinhThanhTra = this.state.theoDoiTienDaThuTrongQuaTrinhThanhTra ? this.state.theoDoiTienDaThuTrongQuaTrinhThanhTra : '';
    params.theoDoiDatDaThuTrongQuaTrinhThanhTra = this.state.theoDoiDatDaThuTrongQuaTrinhThanhTra ? this.state.theoDoiDatDaThuTrongQuaTrinhThanhTra : '';

    params.soQuyetDinhTheoDoiXuLyHanhChinh = this.state.soQuyetDinhTheoDoiXuLyHanhChinh ? this.state.soQuyetDinhTheoDoiXuLyHanhChinh : '';

    params.theoDoiToChucCoSaiPham = this.state.theoDoiToChucCoSaiPham ? this.state.theoDoiToChucCoSaiPham : '';
    params.toChucTheoDoiSaiPham = this.state.toChucTheoDoiSaiPham ? this.state.toChucTheoDoiSaiPham : null;

    params.theoDoiCaNhanCoSaiPham = this.state.theoDoiCaNhanCoSaiPham ? this.state.theoDoiCaNhanCoSaiPham : '';
    params.caNhanTheoDoiSaiPham = this.state.caNhanTheoDoiSaiPham ? this.state.caNhanTheoDoiSaiPham : null;

    // xử lý về kinh tế

    params.tongSoTienThuHoiTheoDoiXuLyVeKinhTe = this.state.tongSoTienThuHoiTheoDoiXuLyVeKinhTe ? this.state.tongSoTienThuHoiTheoDoiXuLyVeKinhTe : '';


    params.lyDoThuHoiTheoDoiXuLyVeKinhTe = this.state.lyDoThuHoiTheoDoiXuLyVeKinhTe ? this.state.lyDoThuHoiTheoDoiXuLyVeKinhTe : '';

    params.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe = this.state.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe ? this.state.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe : '';
    params.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe = this.state.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe ? this.state.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe : '';
    params.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe = this.state.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe ? this.state.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe : '';

    params.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe = this.state.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe ? this.state.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe : '';

    params.saiPhamKhacTheoDoiXuLyVeKinhTe = this.state.saiPhamKhacTheoDoiXuLyVeKinhTe ? this.state.saiPhamKhacTheoDoiXuLyVeKinhTe : '';

    // xử lý về hình sự
    params.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu = this.state.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu ? this.state.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu : '';
    params.ketQuaChuyenCoQuanDieuTra = this.state.ketQuaChuyenCoQuanDieuTra ? this.state.ketQuaChuyenCoQuanDieuTra : null;

    params.soVuViecTheoDoiXuLyHinhSu = this.state.soVuViecTheoDoiXuLyHinhSu ? this.state.soVuViecTheoDoiXuLyHinhSu : '';

    params.soDoiTuongTheoDoiXuLyHinhSu = this.state.soDoiTuongTheoDoiXuLyHinhSu ? this.state.soDoiTuongTheoDoiXuLyHinhSu : '';

    params.ghiChuTheoDoiXuLyHinhSu = this.state.ghiChuTheoDoiXuLyHinhSu ? this.state.ghiChuTheoDoiXuLyHinhSu : '';

    params.kienNghiTienTheoDoiXuLyKhac = this.state.kienNghiTienTheoDoiXuLyKhac ? this.state.kienNghiTienTheoDoiXuLyKhac : '';
    params.kienNghiDatTheoDoiXuLyKhac = this.state.kienNghiDatTheoDoiXuLyKhac ? this.state.kienNghiDatTheoDoiXuLyKhac : '';
    params.ketQuaThucHienTheoDoiXuLyKhac = this.state.ketQuaThucHienTheoDoiXuLyKhac ? this.state.ketQuaThucHienTheoDoiXuLyKhac : '';

    // ket qua kiem tra

    params.soQuyetDinhKiemTra = this.state.soQuyetDinhKiemTra ? this.state.soQuyetDinhKiemTra : '';
    params.ngayBanHanhKiemTra = this.state.ngayBanHanhKiemTra ? moment(this.state.ngayBanHanhKiemTra).add(7, 'hours').toISOString() : null;
    params.ngayBatDauKiemTra = this.state.ngayBatDauKiemTra ? moment(this.state.ngayBatDauKiemTra).add(7, 'hours').toISOString() : null;
    params.thoiHanKiemTra = this.state.thoiHanKiemTra ? this.state.thoiHanKiemTra : 0;
    params.ngayHetHanKiemTra = this.state.ngayHetHanKiemTraISO ? this.state.ngayHetHanKiemTraISO : null;
    params.canCuKiemTra = this.state.canCuKiemTra ? this.state.canCuKiemTra : '';
    params.tinhHinhKiemTra = this.state.tinhHinhKiemTra ? this.state.tinhHinhKiemTra : '';
    params.ketQuaKiemTra = this.state.ketQuaKiemTra ? this.state.ketQuaKiemTra : null;
    params.linhVucKetQuaThanhTra = this.state.linhVucKetQuaThanhTra ? this.state.linhVucKetQuaThanhTra : '';

    // Xử lý về hành chính
    params.theoDoiKienNghiXuLyHanhChinhToChucBangTien = this.state.theoDoiKienNghiXuLyHanhChinhToChucBangTien ? this.state.theoDoiKienNghiXuLyHanhChinhToChucBangTien : '';
    params.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac = this.state.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac ? this.state.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac : '';
    params.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien = this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien ? this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien : '';
    params.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac = this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac ? this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac : '';
    params.soKienNghiDaThucHienXong = this.state.soKienNghiDaThucHienXong ? this.state.soKienNghiDaThucHienXong : null;

    delete params['_links'];
    delete params['nguoiSuaInfo'];
    delete params['nguoiTaoInfo'];
    delete params['ngaySua'];
    delete params['ngayTao'];
    delete params['cuocThanhTraId'];
    delete params['doiTuongViPhamId'];
    delete params['listTaiLieuVanThuChuyenCoQuanDieuTra'];
    delete params['listTaiLieuVanThuKienNghiXuLyKhac'];
    delete params['trangThaiDoiTuongViPhamInfo'];
    delete params['coQuanDieuTraThanhTraInfo'];
    delete params['loaiDoiTuongInfo'];
    delete params['tienDoInfo'];
    delete params['tinhTrangThoiHanInfo'];
    delete params['toChucTheoDoiSaiPhamInfo'];
    delete params['caNhanTheoDoiSaiPhamInfo'];
    delete params['coQuanDieuTraInfo'];
    delete params['ketQuaChuyenCoQuanDieuTraInfo'];
    delete params['ketQuaKiemTraInfo'];
    delete params['donDocDoiTuongs'];
    delete params['listTaiLieuVanThu'];
    delete params['theoDoiLanNopTien'];

    return params;
  }

  handleSave() {
    let params = this.getParams();
    this.pushTaiLieu(this.state.doiTuongViPhamId)
    this.setState({
      showNoiDungKienNghi: true,
      showNoiDungTheoDoi: true,
      showNoiDungDonDoc: true,
      showNoiDungKiemTra: true,
      btnLoading: true,
      btnSaveLoading: true
    }, () => {
      if (this.state.enableDonDoc) {
        this.donDoc.handleSave(() => {
          this.updateDoiTuongViPham(params);
        });
      } else {
        this.updateDoiTuongViPham(params);
      }
    })

  }

  handleKetThuc() {

    this.setState({
      showNoiDungKienNghi: true,
      showNoiDungTheoDoi: true,
      showNoiDungDonDoc: true,
      showNoiDungKiemTra: true
    }, () => {
      let self = this;
      setTimeout(function () {
        if (self.validateSubmitForm()) {
          self.setState({
            showDialogConfirm: true
          })
        }
      }, 100);
    })
  }

  closeDialogConfirm() {
    this.setState({
      showDialogConfirm: false
    })
  }

  onClickConfirmKetThuc() {
    this.setState({
      showDialogConfirm: false,
      btnLoading: true
    }, () => {
      let params = this.getParams();
      params.tienDo = 'HOAN_THANH';
      this.pushTaiLieu(this.state.doiTuongViPhamId);
      if (this.state.enableDonDoc) {
        this.donDoc.handleSave(() => {
          let message = 'Hoàn thành theo dõi thực hiện đối với ' + this.state.ten
          this.updateDoiTuongViPham(params, message);
        });
      } else {
        let message = 'Hoàn thành theo dõi thực hiện đối với ' + this.state.ten
        this.updateDoiTuongViPham(params, message);
      }
    });
  }

  updateDoiTuongViPham(data, message) {
    let params = {
      doiTuongViPhams: [
        data
      ]
    }
    ThanhTra.actions.updateDoiTuongViPham.request('', params).then(res => {
      //do something
      Toastr(message ? message : msg.saveDoiTuongTTSuccess, 'success');
      this.handleBack(true);
      this.props.getListDaTa('getList');
    })
  }

  getCoQuanDieuTraThanhTra() {
    ThanhTra.actions.getCoQuanDieuTraThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataCoQuanDieuTraThanhTra: res.data
        })
      }
    })
  }

  getHinhThucKienNghi() {
    ThanhTra.actions.getHinhThucKienNghi.request().then(res => {
      if (res.data) {
        this.setState({
          dataHinhThucKienNghi: res.data
        })
      }
    })
  }

  getKetLuanVeNoiDungKiemTra() {
    ThanhTra.actions.ketLuanVeNoiDungKiemTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataKetLuanVeNoiDungKiemTra: res.data
        })
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      linhVucThanhTra: nextProps.linhVucThanhTra,
      listDoiTuongViPham: nextProps.listDoiTuongViPham,
      idCuocThanhTra: nextProps.idCuocThanhTra,
      chucNangCuocThanhTra: nextProps.chucNangCuocThanhTra,
      id: nextProps.id,
      isOpen: nextProps.isOpen
    }, () => {
      if (this.state.id && this.state.isOpen === true) {
        this.getChiTietDoiTuongTraThanhTra(this.state.id)
      }
    })
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    }, () => {
      if (name === 'thoiHanKiemTra') {
        this.getThoiHanKiemTra();
      }
    })
    if (name === 'coQuanDieuTraThanhTra') {

    }
    this.handleChangeData();
  }

  onFileChange(data, type) {
    this.setState({
      dataFileDinhKem: data
    });
    this.handleChangeData();
  }

  onFileRemove(id, data, type) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });

    this.setState({
      dataFileDinhKem: data
    });


    this.handleChangeData();
  }

  pushTaiLieu(id) {

    let dataFileDinhKem = this.state.dataFileDinhKem;

    if (dataFileDinhKem.length > 0) {
      let taiLieuVanThu = [];
      let taiLieuVanThuUpdate = [];
      dataFileDinhKem.map((item, i) => {
        if (item.taiLieuVanThuId) {
          taiLieuVanThuUpdate[taiLieuVanThuUpdate.length] = {
            doiTuongViPham: {
              id: Number(id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiQuyTrinh: item.loaiQuyTrinh,
            buocGiaiQuyet: item.buocGiaiQuyet,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : '',
          }
        } else {
          taiLieuVanThu[taiLieuVanThu.length] = {
            doiTuongViPham: {
              id: Number(id)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiQuyTrinh: loaiQuyTrinh,
            buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          }
        }
      });
      if (taiLieuVanThu.length > 0) {
        let params = {
          taiLieuVanThus: taiLieuVanThu
        }
        this.postTaiLieuVanThu(params);
      }
      if (taiLieuVanThuUpdate.length > 0) {
        let params = {
          taiLieuVanThus: taiLieuVanThuUpdate
        }
        this.updateTaiLieuVanThu(params);
      }
    }

    if (this.state.dataTaiLieuVanThuDelete.length > 0) {
      let taiLieuVanThuDelete = [];
      this.state.dataTaiLieuVanThuDelete.map(item => {
        taiLieuVanThuDelete[taiLieuVanThuDelete.length] = { id: item };
      });
      if (taiLieuVanThuDelete.length > 0) {

        let params = {
          taiLieuVanThus: taiLieuVanThuDelete
        }
        this.deleteTaiLieuVanThu(params);
      }
    }

  }


  updateTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  postTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  deleteTaiLieuVanThu(params) {
    GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
    }).catch(error => {
      if (error.response) {
        Toastr(error.response.data.errors[0].detail, 'error');
      }
    });
  }

  handleCheck(name, e) {
    this.setState({
      [name]: e
    })
    if (!e) {

    }
    this.handleChangeData();
  }

  resetData() {
    this.setState({
      idCuocThanhTra: '',
      id: '',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      listTaiLieuVanThu: [],

      btnLoading: false,
      btnSaveLoading: false,

      enableTheoDoi: false,
      enableDonDoc: false,
      enableKiemTra: false,
      hasChange: false,
      backConfirm: false,

      ten: '',
      theoDoiTienDaThuTrongQuaTrinhThanhTra: '',
      theoDoiDatDaThuTrongQuaTrinhThanhTra: '',

      soQuyetDinhTheoDoiXuLyHanhChinh: '',

      theoDoiToChucCoSaiPham: '',
      theoDoiToChucCoSaiPhamInit: '',
      toChucTheoDoiSaiPham: '',
      theoDoiKienNghiXuLyHanhChinhToChucBangTien: '',
      theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac: '',
      theoDoiKienNghiXuLyHanhChinhCaNhanBangTien: '',
      theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac: '',


      theoDoiCaNhanCoSaiPham: '',
      theoDoiCaNhanCoSaiPhamInit: '',
      caNhanTheoDoiSaiPham: '',

      // xử lý về kinh tế

      tongSoTienThuHoiTheoDoiXuLyVeKinhTe: '',

      listTheoDoiLanNopTien: [],

      lyDoThuHoiTheoDoiXuLyVeKinhTe: '',

      saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe: '',
      saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe: '',
      saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe: '',

      lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe: '',

      saiPhamKhacTheoDoiXuLyVeKinhTe: '',

      // xử lý về hình sự
      vanBanDonDocCoQuanDieuTraTheoDoiHinhSu: '',
      ketQuaChuyenCoQuanDieuTra: '',
      soVuViecTheoDoiXuLyHinhSu: '',

      soDoiTuongTheoDoiXuLyHinhSuInit: '',
      soDoiTuongTheoDoiXuLyHinhSu: '',

      ghiChuTheoDoiXuLyHinhSu: '',

      kienNghiTienTheoDoiXuLyKhac: '',
      kienNghiDatTheoDoiXuLyKhac: '',
      ketQuaThucHienTheoDoiXuLyKhac: '',

      soQuyetDinhKiemTra: '',
      ngayBanHanhKiemTra: '',
      ngayBatDauKiemTra: '',
      thoiHanKiemTra: '',
      ngayHetHanKiemTra: '',
      ngayHetHanKiemTraISO: '',
      canCuKiemTra: '',
      tinhHinhKiemTra: '',
      ketQuaKiemTra: '',
      soKienNghiDaThucHienXong: '',
      theoDoiTienDaThuHoiVeNganSachNhaNuoc: '',
      theoDoiDatDaThuHoiVeNganSachNhaNuoc: '',
    }, () => {
      this.props.closeDialog()
    })
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if (pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });

    return pass;
  }

  handleCollapse(name) {
    if (name === 'showNoiDungDonDoc' && this.state.donDocChange === true) {
      this.setState({
        confirmDonDoc: true
      })
    } else {
      this.setState({
        [name]: !this.state[name]
      })
    }
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      if (name === 'ngayBatDauKiemTra') {
        this.setState({
          [name]: e._d
        }, () => {
          this.getThoiHanKiemTra()
        })
      } else {
        this.setState({
          [name]: e._d
        })
      }
    } else {
      if (name === 'ngayBatDauKiemTra') {
        this.setState({
          [name]: e
        }, () => {
          this.getThoiHanKiemTra()
        })
      } else {
        this.setState({
          [name]: e
        })
      }
    }
    this.handleChangeData();
  }

  getThoiHanKiemTra() {
    if (this.state.ngayBatDauKiemTra) {
      this.setState({
        getThoiHanKiemTra: true
      })
      let params = {
        thoiHanThanhTra: this.state.thoiHanKiemTra ? Number(this.state.thoiHanKiemTra) : 0,
        ngayCongBoQD: moment(this.state.ngayBatDauKiemTra).add(7, 'hours').toISOString()
      }
      ThanhTra.actions.getThoiHanThanhTra.request('', params).then(res => {
        if (res.data) {
          this.setState({
            ngayHetHanKiemTra: moment(new Date(res.data)).format('DD/MM/YYYY'),
            ngayHetHanKiemTraISO: res.data
          }, () => {
            this.setState({
              getThoiHanKiemTra: false
            })
            this.pushData()
          })
        }
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
        this.setState({
          getThoiHanKiemTra: false
        })
      });
    } else {
      this.setState({
        ngayHetHanKiemTra: '',
        ngayHetHanKiemTraISO: null
      })
    }
  }

  onChangeDataDonDoc() {
    this.setState({
      donDocChange: true
    })
    this.handleChangeData();
  }

  confirmDonDoc() {
    this.setState({
      confirmDonDoc: false,
      showNoiDungDonDoc: false,
      donDocChange: false
    })
  }

  closeDialogDonDoc() {
    this.setState({
      confirmDonDoc: false
    })
  }

  handleBack(allowBack) {
    if (allowBack == true) {
      this.resetData();
    } else {
      if (this.state.hasChange) {
        this.state.backConfirm = true;
        this.setState({ ...this.state });
      } else {
        this.resetData();
      }
    }
  }

  closeConfirmBack() {
    this.state.backConfirm = false;
    this.setState({ ...this.state });
  }

  handleChangeData() {
    this.setState({
      hasChange: true
    })
  }

  render() {
    let DataDetail = this.state.dataDetail
    return (
      <Dialog
        isOpen={this.state.isOpen}
        onClose={this.handleBack.bind(this)}
        title={`Đối tượng ${this.state.ten}`}
        className="dialog-default wrap-block">
        <section className="wrap-dtkn">
          <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)}
            title={msg.confirmBack} />
          <div className='content-dtkn'>
            <h2 className={`collapse-title pl15 pr15 pt20 ${this.state.showNoiDungKienNghi ? "collapse-open" : "collapse-close pb20"}`}><Link className="title-14" onClick={this.handleCollapse.bind(this, 'showNoiDungKienNghi')}>1. Nội dung kiến nghị</Link></h2>
            <Collapse isOpen={this.state.showNoiDungKienNghi}>
              <NoiDungKienNghiDoiTuongThanhTra linhVucThanhTra={this.state.linhVucThanhTra} chucNangCuocThanhTra={this.state.chucNangCuocThanhTra} {...DataDetail} />
            </Collapse>
          </div>
          <ShowIf condition={this.state.enableTheoDoi}>
            <div>
              <div className='big-border' />
            </div>
            <div className='content-dtkn'>
              <h2 className={`collapse-title pl15 pr15 pt20 ${this.state.showNoiDungTheoDoi ? "collapse-open" : "collapse-close pb20"}`}><Link className="title-14" onClick={this.handleCollapse.bind(this, 'showNoiDungTheoDoi')}>2. Theo dõi thực hiện</Link></h2>
              <Collapse isOpen={this.state.showNoiDungTheoDoi}>
                <div className='pl15 pr15'>
                  <div className='col-100 no-gutter'>
                    <h2 className='title-12 mb10 mt15'>2.1 Xử lý thu hồi</h2>
                    <div className='col-50 pl0 pr0'>
                      <p className='title-group-input'>THU HỒI VỀ NSNN</p>
                      <Input type="sdt" align="right" className='col-50' placeholder='Nhập...' label='Về tiền (đ)' value={this.state.theoDoiTienDaThuHoiVeNganSachNhaNuoc} onChange={this.onChange.bind(this, 'theoDoiTienDaThuHoiVeNganSachNhaNuoc')} name='theoDoiTienDaThuHoiVeNganSachNhaNuoc' />
                      <Input type="sdt" align="right" className='col-50' placeholder='Nhập...' label='Về đất (m2)' value={this.state.theoDoiDatDaThuHoiVeNganSachNhaNuoc} onChange={this.onChange.bind(this, 'theoDoiDatDaThuHoiVeNganSachNhaNuoc')} name='theoDoiDatDaThuHoiVeNganSachNhaNuoc' />
                    </div>
                    <div className='col-50 pl0 pr0'>
                      <p className='title-group-input'>THU HỒI VỀ TỔ CHỨC, ĐƠN VỊ</p>
                      <Input type="sdt" align="right" className='col-50' placeholder='Nhập...' label='Về tiền (đ)' value={this.state.theoDoiTienDaThuTrongQuaTrinhThanhTra} onChange={this.onChange.bind(this, 'theoDoiTienDaThuTrongQuaTrinhThanhTra')} name='theoDoiTienDaThuTrongQuaTrinhThanhTra' />
                      <Input type="sdt" align="right" className='col-50' placeholder='Nhập...' label='Về đất (m2)' value={this.state.theoDoiDatDaThuTrongQuaTrinhThanhTra} onChange={this.onChange.bind(this, 'theoDoiDatDaThuTrongQuaTrinhThanhTra')} name='theoDoiDatDaThuTrongQuaTrinhThanhTra' />
                    </div>
                  </div>
                  <div className='mb20 mt5'>
                    <div className='line-border' />
                  </div>

                  <h2 className='title-12 mb10'>2.2. Xử lý về kinh tế</h2>
                  <div className='row pl10 pr10'>
                    <Input className='col-25' type='sdt' align='right' label='Tổng số tiền phải thu hồi (đ)' placeholder='Nhập...' value={this.state.tongSoTienThuHoiTheoDoiXuLyVeKinhTe} onChange={this.onChange.bind(this, 'tongSoTienThuHoiTheoDoiXuLyVeKinhTe')} name='tongSoTienThuHoiTheoDoiXuLyVeKinhTe' />
                    {/*list lần nộp tiền*/}
                    <ListLanNopTien data={this.state.listTheoDoiLanNopTien} onChange={this.onChange.bind(this, 'listTheoDoiLanNopTien')} name='listTheoDoiLanNopTien' />
                    {/*End*/}
                    <TextArea className='col-100' label='Lý do' placeholder='Nhập...' value={this.state.lyDoThuHoiTheoDoiXuLyVeKinhTe} onChange={this.onChange.bind(this, 'lyDoThuHoiTheoDoiXuLyVeKinhTe')} name='lyDoThuHoiTheoDoiXuLyVeKinhTe' maxLength={1000}/>

                    <h2 className='col-100 mb10 mt5 txt-bold txt-upper txt-12'>Sai phạm về đất đai kiến nghị thu hồi</h2>
                    <Input className='col-25' type='sdt' align='right' label='Phải thu (m2)' placeholder='Nhập...' value={this.state.saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe} onChange={this.onChange.bind(this, 'saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe')} name='saiPhamVeDatDaiPhaiThuTheoDoiXuLyVeKinhTe' />
                    <Input className='col-25' type='sdt' align='right' label='Đã thu (m2)' placeholder='Nhập...' value={this.state.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe} onChange={this.onChange.bind(this, 'saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe')} name='saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe' />
                    <Input className='col-25' type='sdt' align='right' label='Còn phải thu (m2)' placeholder='Nhập...' value={this.state.saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe} onChange={this.onChange.bind(this, 'saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe')} name='saiPhamVeDatDaiConThuTheoDoiXuLyVeKinhTe' />
                    <TextArea className='col-100' label='Lý do' placeholder='Nhập...' value={this.state.lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe} onChange={this.onChange.bind(this, 'lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe')} name='lyDoSaiPhamVeDatDaiThuHoiTheoDoiXuLyVeKinhTe' maxLength={1000}/>

                    <h2 className='col-100 mb10 mt5 txt-bold txt-upper txt-12'>Sai phạm khác</h2>
                    <TextArea className='col-100' label='Nội dung sai phạm khác' placeholder='Nhập...' value={this.state.saiPhamKhacTheoDoiXuLyVeKinhTe} onChange={this.onChange.bind(this, 'saiPhamKhacTheoDoiXuLyVeKinhTe')} name='saiPhamKhacTheoDoiXuLyVeKinhTe' maxLength={1000} />
                  </div>
                  <div className='mb20 mt5'>
                    <div className='line-border' />
                  </div>

                  <h2 className='title-12 mb10'>2.3. Xử lý về hành chính</h2>
                  <div className='row pl10 pr10'>
                    <Input className='col-25' label='Số quyết định xử lý hành chính' placeholder='Nhập...' bindValidator={this} channel='formTaoDon' value={this.state.soQuyetDinhTheoDoiXuLyHanhChinh} onChange={this.onChange.bind(this, 'soQuyetDinhTheoDoiXuLyHanhChinh')} name='soQuyetDinhTheoDoiXuLyHanhChinh' maxLength={255} />

                    <InputList label='Tổ chức có sai phạm' hasCount={true} countUnit='tổ chức' data={this.state.theoDoiToChucCoSaiPhamInit} onChange={this.onChange.bind(this, 'theoDoiToChucCoSaiPham')} name='theoDoiToChucCoSaiPham' />
                    <Input type="sdt" className='col-25' placeholder='Nhập...' label='Bằng tiền (đ)' value={this.state.theoDoiKienNghiXuLyHanhChinhToChucBangTien} onChange={this.onChange.bind(this, 'theoDoiKienNghiXuLyHanhChinhToChucBangTien')} name='theoDoiKienNghiXuLyHanhChinhToChucBangTien' />
                    <Input className='col-25' label='Bằng hình thức khác' placeholder='Nhập...' value={this.state.theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac} onChange={this.onChange.bind(this, 'theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac')} name='theoDoiKienNghiXuLyHanhChinhToChucBangHinhThucKhac' maxLength={255} />
                    <InputList label='Cá nhân có sai phạm' hasCount={true} countUnit='cá nhân' data={this.state.theoDoiCaNhanCoSaiPhamInit} onChange={this.onChange.bind(this, 'theoDoiCaNhanCoSaiPham')} name='theoDoiCaNhanCoSaiPham' />
                    <Input type="sdt" className='col-25' placeholder='Nhập...' label='Bằng tiền (đ)' value={this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangTien} onChange={this.onChange.bind(this, 'theoDoiKienNghiXuLyHanhChinhCaNhanBangTien')} name='theoDoiKienNghiXuLyHanhChinhCaNhanBangTien' />
                    <Input className='col-25' label='Bằng hình thức khác' placeholder='Nhập...' value={this.state.theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac} onChange={this.onChange.bind(this, 'theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac')} name='theoDoiKienNghiXuLyHanhChinhCaNhanBangHinhThucKhac' maxLength={255} />
                  </div>

                  <div className='mb20 mt5'>
                    <div className='line-border' />
                  </div>

                  <h2 className='title-12 mb10'>2.4. Xử lý về hình sự</h2>
                  <div className='row pl10 pr10'>
                    <Input className='col-25' label='Văn bản đôn đốc cơ quan điều tra' placeholder='Nhập...' value={this.state.vanBanDonDocCoQuanDieuTraTheoDoiHinhSu} onChange={this.onChange.bind(this, 'vanBanDonDocCoQuanDieuTraTheoDoiHinhSu')} name='vanBanDonDocCoQuanDieuTraTheoDoiHinhSu' maxLength={255} />
                    <DropDownMulipleUse data={this.state.dataKetQuaChuyenCoQuanDieuTra} keyName='giaTri' valueName='ten' className='col-25' label='Kết quả chuyển cơ quan điều tra' selectedValue={this.state.ketQuaChuyenCoQuanDieuTra} onChange={this.onChange.bind(this, 'ketQuaChuyenCoQuanDieuTra')} name='ketQuaChuyenCoQuanDieuTra' />
                  </div>
                  <div className='row pl10 pr10'>
                    <InputNumber className='col-25' label='Số vụ việc' placeholder='Nhập...' value={this.state.soVuViecTheoDoiXuLyHinhSu} onChange={this.onChange.bind(this, 'soVuViecTheoDoiXuLyHinhSu')} name='soVuViecTheoDoiXuLyHinhSu' />
                    <InputList label='Tên đối tượng' hasCount={true} countUnit='đối tượng' data={this.state.soDoiTuongTheoDoiXuLyHinhSuInit} onChange={this.onChange.bind(this, 'soDoiTuongTheoDoiXuLyHinhSu')} name='soDoiTuongTheoDoiXuLyHinhSu' />
                    <TextArea className='col-100' label='Ghi chú' placeholder='Nhập...' value={this.state.ghiChuTheoDoiXuLyHinhSu} onChange={this.onChange.bind(this, 'ghiChuTheoDoiXuLyHinhSu')} name='ghiChuTheoDoiXuLyHinhSu' maxLength={1000} />
                  </div>
                  <div className='mb20 mt5'>
                    <div className='line-border' />
                  </div>

                  <h2 className='title-12 mb10'>2.5. Kiến nghị hoàn thiện cơ chế chính sách</h2>
                  <div className='row pl10 pr10'>
                    <Input className='col-25' type='sdt' label='Số kiến nghị đã thực hiện xong' placeholder='Nhập...' value={this.state.soKienNghiDaThucHienXong} onChange={this.onChange.bind(this, 'soKienNghiDaThucHienXong')} name='soKienNghiDaThucHienXong' maxLength={255} />
                  </div>

                  <h2 className='title-12 mb10'>2.6. Xử lý khác</h2>
                  <div className='row pl10 pr10'>
                    <Input className='col-25' type='sdt' align='right' label='Kiến nghị tiền (đ)' placeholder='Nhập...' value={this.state.kienNghiTienTheoDoiXuLyKhac} onChange={this.onChange.bind(this, 'kienNghiTienTheoDoiXuLyKhac')} name='kienNghiTienTheoDoiXuLyKhac' />
                    <Input className='col-25' type='sdt' align='right' label='Kiến nghị đất (m2)' placeholder='Nhập...' value={this.state.kienNghiDatTheoDoiXuLyKhac} onChange={this.onChange.bind(this, 'kienNghiDatTheoDoiXuLyKhac')} name='kienNghiDatTheoDoiXuLyKhac' />
                    <TextArea className='col-100' label='Kết quả thực hiện kiến nghị khác' placeholder='Nhập...' value={this.state.ketQuaThucHienTheoDoiXuLyKhac} onChange={this.onChange.bind(this, 'ketQuaThucHienTheoDoiXuLyKhac')} name='ketQuaThucHienTheoDoiXuLyKhac' maxLength={1000} />
                  </div>
                </div>
              </Collapse>
            </div>
          </ShowIf>

          <ShowIf condition={this.state.enableDonDoc}>
            <div>
              <div className='big-border' />
            </div>
            <div className='content-dtkn custom-collapse'>
              <h2 className={`collapse-title pl15 pr15 pt20 ${this.state.showNoiDungDonDoc ? "collapse-open" : "collapse-close pb20"}`}><Link className="title-14" onClick={this.handleCollapse.bind(this, 'showNoiDungDonDoc')}>3. Đôn đốc</Link></h2>
              <Collapse isOpen={this.state.showNoiDungDonDoc}>
                <ListDonDoc bindValidator={this} id={this.state.id} onChangeData={this.onChangeDataDonDoc.bind(this)} onRef={donDoc => (this.donDoc = donDoc)} />
              </Collapse>
            </div>
          </ShowIf>

          <ShowIf condition={this.state.enableKiemTra}>
            <div>
              <div className='big-border' />
            </div>
            <div className='content-dtkn custom-collapse'>
              <h2 className={`collapse-title pl15 pr15 pt20 ${this.state.showNoiDungKiemTra ? "collapse-open" : "collapse-close pb20"}`}><Link className="title-14" onClick={this.handleCollapse.bind(this, 'showNoiDungKiemTra')}>4. Kiểm Tra</Link></h2>
              <Collapse isOpen={this.state.showNoiDungKiemTra}>
                <div className='pl15 pr15 pt15'>
                  <div className='row pl10 pr10'>
                    <Input className='col-25' bindValidator={this} channel='formTaoDon' require label='Số quyết định' placeholder='Nhập...' value={this.state.soQuyetDinhKiemTra} onChange={this.onChange.bind(this, 'soQuyetDinhKiemTra')} name='soQuyetDinhKiemTra' maxLength={255}/>
                    <DatePicker className='col-25' bindValidator={this} channel='formTaoDon' endDate={new Date()} require label='Ngày ban hành' value={this.state.ngayBanHanhKiemTra} onChange={this.handleChangeDate.bind(this, 'ngayBanHanhKiemTra')} name='ngayBanHanhKiemTra' />
                    <DatePicker label='Ngày bắt đầu' className='col-25' value={this.state.ngayBatDauKiemTra} onChange={this.handleChangeDate.bind(this, 'ngayBatDauKiemTra')} name='ngayBatDauKiemTra' require bindValidator={this} channel="formTaoDon" />
                    <div className='wrap-thoihan col-25'>
                      <Input label='Thời hạn kiểm tra (ngày làm việc)' type='sdt' className='col-100 no-gutter' value={this.state.thoiHanKiemTra} onChange={this.onChange.bind(this, 'thoiHanKiemTra')} name='thoiHanKiemTra' />
                      <span className='thoihan-value'>
                        <ShowIf condition={!this.state.getThoiHanKiemTra}>
                          <span>
                            {this.state.ngayHetHanKiemTra ? this.state.ngayHetHanKiemTra : ''}
                          </span>
                        </ShowIf>
                        <ShowIf condition={this.state.getThoiHanKiemTra}>
                          <span className='icon-loader'></span>
                        </ShowIf>
                      </span>
                    </div>
                    <TextArea className='col-100' label='Căn cứ kiểm tra' value={this.state.canCuKiemTra} onChange={this.onChange.bind(this, 'canCuKiemTra')} name='canCuKiemTra' />
                    <TextArea className='col-100' label='Tình hình kiểm tra' value={this.state.tinhHinhKiemTra} onChange={this.onChange.bind(this, 'tinhHinhKiemTra')} name='tinhHinhKiemTra' />
                    <DropDownMulipleUse data={this.state.dataKetLuanVeNoiDungKiemTra} keyName='giaTri' valueName='ten' className='col-25' label='Kết luận về nội dung kiểm tra' selectedValue={this.state.ketQuaKiemTra} onChange={this.onChange.bind(this, 'ketQuaKiemTra')} name='ketQuaKiemTra' />
                  </div>
                </div>
              </Collapse>
            </div>
          </ShowIf>

          <div className='content-dtkn pl15 pr15 pb10'>
            <ShowIf condition={this.state.showFile}>
              <ContainerFileDinhKem
                label="Danh sách văn bản xử lý"
                name='taiLieuVanThuDoiTuongKienNghi'
                bindValidator={this}
                data={this.state.listTaiLieuVanThu}
                onFileRemove={this.onFileRemove.bind(this)}
                onFileChange={this.onFileChange.bind(this)} />
            </ShowIf>
          </div>
          <div>
            <div className='pr10 pl10'>
              <div className="box-bottom">
                <Link className="btn-action btn-close" onClick={this.handleBack.bind(this)}><span>Đóng</span></Link>
                <Link className={'btn-action btn-save action-todo ' + (this.state.btnSaveLoading ? "btn-loading-inline" : (this.state.btnLoading && 'btn-disable'))} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
                <Link className={'btn-action btn-complete btn-right-position action-todo ' + (this.state.btnSaveLoading ? "btn-disable" : (this.state.btnLoading && 'btn-loading-inline'))} onClick={this.handleKetThuc.bind(this)}><span>Hoàn Thành</span></Link>
              </div>
            </div>
          </div>

          <Dialog
            isOpen={this.state.confirmDonDoc}
            onClose={this.closeDialogDonDoc.bind(this)}
            title='Xác nhận'
            className="reception-dialog delete-dialog wrap-block"
          >
            <div className="pt-dialog-body mb0">
              <p className='pt10 pb20 txt-center'>{msg.confirmDonDoc}</p>
            </div>
            <div className="box-bottom col-100">
              <Link className="btn-action btn-close action-todo" onClick={this.closeDialogDonDoc.bind(this)}><span>Không</span></Link>
              <Link className="btn-action btn-green action-todo" onClick={this.confirmDonDoc.bind(this)}><span>Đồng ý</span></Link>
            </div>
          </Dialog>

          <Dialog
            isOpen={this.state.showDialogConfirm}
            onClose={this.closeDialogConfirm.bind(this)}
            title='Xác nhận'
            className="reception-dialog delete-dialog wrap-block"
          >
            <div className="pt-dialog-body mb0">
              <p className='pt10 pb20 txt-center'>{`Sau khi hoàn thành theo dõi thực hiện, bạn sẽ không cập nhật được thông tin cho ${this.state.ten}`}</p>
            </div>
            <div className="box-bottom col-100">
              <Link className="btn-action btn-close action-todo" onClick={this.closeDialogConfirm.bind(this)}><span>Không</span></Link>
              <Link className="btn-action btn-green action-todo" onClick={this.onClickConfirmKetThuc.bind(this)}><span>Đồng ý</span></Link>
            </div>
          </Dialog>
        </section>
      </Dialog>
    );
  }
}

DoiTuongKienNghi.defaultProps = {
  validators: {
    formTaoDon: []
  },
  linhVucThanhTra: '',
  listDoiTuongViPham: []
}

export default validatable(DoiTuongKienNghi);


// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/sub-view/DoiTuongKienNghi.jsx